/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ImageLinkItem } from "./image-link-item";

const ImageLinkComponent = (props) => {

    const { component } = props || {};
    const { image_list: imageList, sectionName } = component || {};

    const hasImageList = imageList && imageList.length > 0;

    return (
        <div className='simplicity-image-link'>
            {sectionName && <h4>{sectionName}</h4>}
            {hasImageList &&
                <div className='image-link-items-container'>
                    {imageList.map((item, index) => (
                        <ImageLinkItem item={item} key={`image-link-item-${index}`} />
                    ))}
                </div>}
        </div>
    );
};

ImageLinkComponent.displayName = "ImageLinkComponent";
export { ImageLinkComponent };
